import {
  GET_ALERTS_START,
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAIL,
  GET_ALERT_BY_ID_START,
  GET_ALERT_BY_ID_SUCCESS,
  GET_ALERT_BY_ID_FAIL,
  GET_ALERT_BY_NAME_START,
  GET_ALERT_BY_NAME_SUCCESS,
  GET_ALERT_BY_NAME_FAIL,
  CREATE_ALERT_START,
  CREATE_ALERT_SUCCESS,
  CREATE_ALERT_FAIL,
  UPDATE_ALERT_START,
  UPDATE_ALERT_SUCCESS,
  UPDATE_ALERT_FAIL,
  DELETE_ALERT_START,
  DELETE_ALERT_SUCCESS,
  DELETE_ALERT_FAIL,
  EXECUTE_ALERTS_START,
  EXECUTE_ALERTS_SUCCESS,
  EXECUTE_ALERTS_FAIL,
  GET_ATTRIBUTE_VALUES_START,
  GET_ATTRIBUTE_VALUES_SUCCESS,
  GET_ATTRIBUTE_VALUES_FAIL,
  GET_ALERTS_LIST_START,
  GET_ALERTS_LIST_SUCCESS,
  GET_ALERTS_LIST_FAIL,
} from '../../actions/AlertManagement/ActionTypes';

const initialState = {
  // Alerts data
  alerts: [],
  alertsList: [],
  alert: null,
  alertError: null,
  
  // Attribute values
  attributeValues: {},
  
  // Execute result
  executeResult: null,
  
  // Loading states
  loadingAlerts: false,
  loadingAlert: false,
  loadingAlertByName: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingExecute: false,
  loadingAttributeValues: false,
  loadingAlertsList: false,
};

const AlertManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get All Alerts
    case GET_ALERTS_START:
      return {
        ...state,
        loadingAlerts: true,
        alertError: null,
      };
    case GET_ALERTS_SUCCESS:
      return {
        ...state,
        alerts: action.data || [],
        loadingAlerts: false,
        alertError: null,
      };
    case GET_ALERTS_FAIL:
      return {
        ...state,
        loadingAlerts: false,
        alertError: action.error,
      };

    // Get Alert By ID
    case GET_ALERT_BY_ID_START:
      return {
        ...state,
        loadingAlert: true,
        alertError: null,
      };
    case GET_ALERT_BY_ID_SUCCESS:
      return {
        ...state,
        alert: action.data,
        loadingAlert: false,
        alertError: null,
      };
    case GET_ALERT_BY_ID_FAIL:
      return {
        ...state,
        loadingAlert: false,
        alertError: action.error,
      };

    // Get Alert By Name
    case GET_ALERT_BY_NAME_START:
      return {
        ...state,
        loadingAlertByName: true,
        alertError: null,
      };
    case GET_ALERT_BY_NAME_SUCCESS:
      return {
        ...state,
        alert: action.data,
        loadingAlertByName: false,
        alertError: null,
      };
    case GET_ALERT_BY_NAME_FAIL:
      return {
        ...state,
        loadingAlertByName: false,
        alertError: action.error,
      };

    // Create Alert
    case CREATE_ALERT_START:
      return {
        ...state,
        loadingCreate: true,
        alertError: null,
      };
    case CREATE_ALERT_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        alertError: null,
      };
    case CREATE_ALERT_FAIL:
      return {
        ...state,
        loadingCreate: false,
        alertError: action.error,
      };

    // Update Alert
    case UPDATE_ALERT_START:
      return {
        ...state,
        loadingUpdate: true,
        alertError: null,
      };
    case UPDATE_ALERT_SUCCESS:
      return {
        ...state,
        alert: action.data,
        loadingUpdate: false,
        alertError: null,
      };
    case UPDATE_ALERT_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        alertError: action.error,
      };

    // Delete Alert
    case DELETE_ALERT_START:
      return {
        ...state,
        loadingDelete: true,
        alertError: null,
      };
    case DELETE_ALERT_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        alertError: null,
      };
    case DELETE_ALERT_FAIL:
      return {
        ...state,
        loadingDelete: false,
        alertError: action.error,
      };

    // Execute Alerts
    case EXECUTE_ALERTS_START:
      return {
        ...state,
        loadingExecute: true,
        alertError: null,
      };
    case EXECUTE_ALERTS_SUCCESS:
      return {
        ...state,
        executeResult: action.data,
        loadingExecute: false,
        alertError: null,
      };
    case EXECUTE_ALERTS_FAIL:
      return {
        ...state,
        loadingExecute: false,
        alertError: action.error,
      };

    // Get Attribute Values
    case GET_ATTRIBUTE_VALUES_START:
      return {
        ...state,
        loadingAttributeValues: true,
      };
    case GET_ATTRIBUTE_VALUES_SUCCESS:
      return {
        ...state,
        attributeValues: {
          ...state.attributeValues,
          [action.attributeName]: action.data || [],
        },
        loadingAttributeValues: false,
      };
    case GET_ATTRIBUTE_VALUES_FAIL:
      return {
        ...state,
        loadingAttributeValues: false,
      };

    // Get Alerts List
    case GET_ALERTS_LIST_START:
      return {
        ...state,
        loadingAlertsList: true,
        alertError: null,
      };
    case GET_ALERTS_LIST_SUCCESS:
      return {
        ...state,
        alertsList: action.data || [],
        loadingAlertsList: false,
        alertError: null,
      };
    case GET_ALERTS_LIST_FAIL:
      return {
        ...state,
        loadingAlertsList: false,
        alertError: action.error,
      };

    default:
      return state;
  }
};

export default AlertManagementReducer;

